module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-local"
  }, [_c('div', {
    staticClass: "row center-v"
  }, [_c('div', {
    staticClass: "cols s_24 m_24"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), (_vm.data.server_response) ? _c('p', {
    staticClass: "statusError"
  }, [_vm._v(_vm._s(_vm.data.server_response.message))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.fields), function(field, i) {
    return [(field.type == "select") ? [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(field.label))]), _vm._v(" "), (field.multiple == true) ? _c('dropdown-multiple', {
      attrs: {
        "name": field.name,
        "options": field.options,
        "placeholder": field.placeholder
      },
      on: {
        "changed": _vm.ddmultipleChanged
      }
    }) : (field.multiple == false) ? _c('dropdown-write', {
      attrs: {
        "name": field.name,
        "options": field.options,
        "placeholder": field.placeholder
      },
      on: {
        "changed": _vm.ddwriteChanged
      }
    }) : _c('dropdown', {
      ref: ("input-" + i + ":" + (field.type)),
      refInFor: true,
      attrs: {
        "data": field,
        "name": field.name
      },
      on: {
        "changed": _vm.dropdownChange
      }
    })] : (field.type == "radiogroup") ? [_c('div', {
      staticClass: "containerRadio"
    }, [_c('label', {
      staticClass: "BlockRadio"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(field.label))]), _vm._v(" "), _c('radiogroup', {
      ref: ("input-" + i + ":" + (field.type)),
      refInFor: true,
      staticClass: "radiogroup",
      attrs: {
        "name": field.name,
        "group": field.fields,
        "required": field.required,
        "validator": field.validator || ""
      },
      on: {
        "RADIOGROUP_CHANGED": _vm.radioWasChanged
      }
    })], 1)])] : (field.type == "textarea") ? [_c('span', {
      staticClass: "label"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(field.label) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('v-textarea', {
      key: ("input-" + i + ":" + (field.type)),
      ref: ("input-" + i + ":" + (field.type)),
      refInFor: true,
      attrs: {
        "data": field
      },
      on: {
        "changedText": _vm.textareaChange
      }
    })] : [_c('span', {
      staticClass: "label"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(field.label) + "\n\t\t\t\t\t\t")]), _vm._v(" "), (field.type == "checkbox") ? [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(field.label))]), _vm._v(" "), _c('label', {
      staticClass: "BlockCheckbox"
    }, [(field.type == "checkbox") ? _c('vinput', {
      key: ("input-" + i + ":" + (field.type)),
      ref: ("input-" + i + ":" + (field.type)),
      refInFor: true,
      attrs: {
        "type": field.type,
        "name": field.name,
        "value": field.value,
        "placeholder": field.placeholder || "",
        "required": field.required,
        "check": field.check ? field.check : "",
        "validator": field.validator || ""
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "label",
      domProps: {
        "innerHTML": _vm._s(field.text)
      }
    })], 1)] : _c('vinput', {
      key: ("input-" + i + ":" + (field.type)),
      ref: ("input-" + i + ":" + (field.type)),
      refInFor: true,
      attrs: {
        "type": field.type,
        "name": field.name,
        "value": field.value,
        "text": field.text,
        "repeat": field.repeat,
        "required": field.required,
        "placeholder": field.placeholder,
        "validator": field.validator || "",
        "identic": field.identic || ""
      }
    })]]
  }), _vm._v(" "), _c('div', {
    staticClass: "containerButton"
  }, [_c('vsubmit', {
    on: {
      "COMPLETE": _vm.onComplete,
      "INCOMPLETE": _vm.onIncomplete
    }
  }, [_c('div', {
    staticClass: "buttonStep1"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.data.button) + "\n\t\t\t\t\t\t")])])], 1)], 2)])]), _vm._v(" "), _c('grecaptcha', {
    attrs: {
      "request": _vm.request,
      "payload": _vm.payload
    },
    on: {
      "SENDFORM": _vm.onRecaptchaSubmit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f91c76e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/forms/default.vue
// module id = 293
// module chunks = 38